import "./banner/Banner.css";
import './Home.css'
import Banner from "./banner/Banner";
import Sport_programs from "./sport-programs/Sport_programs";
import All_activities from "../about_us/all_activities/All_activities";
import Contact from "./contact/Contact";
import Sports_event from "./sports_events/Sports_event";
import Who_we_are from "./who_we_are/Who_we_are";
import Testimonials from "./testimonials/Testimonials";
import Blog_preview from "./blog_preview/Blog_preview";

function Home() {
  return (
    <>
      <Banner />

      <div className="bg_img_holder">
        <Who_we_are />
        <Sport_programs />   {/* our activites */}           
        <All_activities />   {/* our specilaisation */}   
        <Testimonials />
        <Sports_event />
        {/* <Blog_preview />         */}
        <Contact />
      </div>
    </>
  );
}

export default Home;
